<template>
	<div>
		<a-modal :title="audit ? types==1?'流动资产盘盈入库重新提交':'流动资产盘亏入库重新提交':types==1?'流动资产-盘盈入库':'流动资产-盘亏入库'" :visible="profitvisible" @cancel="profitvisible = false" :confirm-loading="confirmLoading"
		 width="70%" :maskClosable="false">
			<template slot="footer">
				<a-button key="submit" type="primary" :loading="loading" @click="handleOkCar"> 提交 </a-button>
				<a-button key="back" @click="profitvisible = false"> 取消 </a-button>
			</template>
			<a-form-model :model="form" :rules="rules" ref="ruleForm" :label-col="labelCol" :wrapper-col="wrapperCol">
				<a-row style="margin-bottom: 15px"><span class="form_title">表单信息</span></a-row>
				<a-row>
					<a-form-model-item label="选择抄送人" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
						<ccChange :data="ccC" @targetKeys="getdata" v-if="isRouterAlive" />
					</a-form-model-item>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="盘点原因" prop="reason" :rules="{
		        required: true,
		        message: '请输入盘点原因',
		        trigger: 'change',
		      }"
						 :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
							<a-input v-model="form.reason" placeholder="请输入" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-table :data-source="form.details" bordered :pagination="false">
						<a-table-column key="index" title="序号" data-index="index">
							<template scope="text, record, index">{{ index+1 }}</template>
						</a-table-column>
						<a-table-column key="name" title="物品名称" ellipsis="true" data-index="name" />
						<a-table-column key="model" title="规格型号" ellipsis="true" data-index="model" />
						<a-table-column key="is_inspected" title="是否检定" data-index="is_inspected">
							<template scope="text">
								{{ instrumentMap[text] }}
							</template>
						</a-table-column>
						<a-table-column key="storage_num" title="库存数量" ellipsis="true" data-index="storage_num" />
						<a-table-column key="inventoryNum" :title="types==1?'* 盘点后增加数量':'* 盘点后减少数量'" class="note" data-index="inventoryNum" width="200px">
							<template scope="text,record">
								<a-input type="number" @blur="set_max_min(record)" v-model="record.inventoryNum" />
							</template>
						</a-table-column>
						<a-table-column key="unit" title="单位" data-index="unit" />
						<a-table-column key="action" title="操作" data-index="action" width="150px">
							<template scope="text,record,index">
								<a @click="removeTo(index,record)">删除</a>
							</template>
						</a-table-column>
					</a-table>
				</a-row>
			</a-form-model>
		</a-modal>
	</div>
</template>

<script>
	import {
		consumables_save,
		consumables_code
	} from '@/api/assetmenag'
	import ccChange from '@/components/module/ccChange'
	export default {
		components: {
			ccChange
		},
		data() {
			return {
				profitvisible:false,
				form:{},
				ccC: 'hcpd',
				types:'',
				isRouterAlive: false,
				labelCol3: {
					span: 2,
				},
				wrapperCol3: {
					span: 22,
				},
				audit:false,
			}
		},
		props: {
			data: {
				type: Object,
				default: true,
			},
			selected: {
				type: Object,
				default: true,
			},
		},
		watch: {
			data(val, old) {
				console.log(val, old)
			},
			selected(val, old) {
				console.log(val, old)
			},
		},
		created() {},
		methods: {
			showprofit(res) {
				if (res) {
					this.audit = true
					this.form = res
					this.form.details.forEach(item=>{
						item.is_inspected=item.isInspected
						item.amount=item.storageNum
					})
				} else {
					this.form = {}
					this.selected.selectedRowKeysTabItems.forEach((item) => {
						item['inventoryNum'] = 1
					})
					this.form.details = this.selected.selectedRowKeysTabItems
				}
				this.types=1
				this.isRouterAlive = false
				this.$nextTick(() => {
					this.isRouterAlive = true
				})
				consumables_code().then(res => {
					this.form.applyCode = res.data
				})
				this.profitvisible = true
			},
			showloss(res){
				if (res) {
					this.audit = true
					this.form = res
					this.form.details.forEach(item=>{
						item.is_inspected=item.isInspected
						item.amount=item.storageNum
					})
				} else {
					this.form = {}
					this.selected.selectedRowKeysTabItems.forEach((item) => {
						item['inventoryNum'] = 1
					})
					this.form.details = this.selected.selectedRowKeysTabItems
				}
				this.types=2
				this.isRouterAlive = false
				this.$nextTick(() => {
					this.isRouterAlive = true
				})
				consumables_code().then(res => {
					this.form.applyCode = res.data
				})
				this.profitvisible = true
			},
			getdata(data) {
				this.form.cc = data
			},
			//限制最大值
			set_max_min(row) {
				if (row.inventoryNum < 1) {
					row.inventoryNum = 0
				}
				this.$forceUpdate()
			},
			removeTo(idx, row) {
				this.form.details.splice(idx, 1)
				if(this.audit==false){
					this.selected.selectedRowKeysTab.splice(idx, 1)
				}
				
			},
			handleOkCar() {
				this.$refs.ruleForm.validate((valid) => {
					if (valid) {
						this.form.details.forEach(item=>{
							item.isInspected=item.is_inspected
							item.storageNum=item.amount
							item.spuId=item.id
						})
						this.form.types = this.types
						this.form.cc = this.form.cc.length ? this.form.cc.join(',') : ''
						console.log(this.form,'1111111111111111111111111')
						var array = {}
						// this.form.forEach(item => {
							Object.assign(array, {
								applyCode: this.form.applyCode,
								cc: this.form.cc,
								reason: this.form.reason,
								types: this.form.types,
								details: []
							})
							this.form.details.forEach(item2 => {
					        	var list = {
									averagePrice: item2.average_price,
								companyName: item2.company_name,
								createBy: item2.create_by,
								// createTime: item2.create_time,
								deptId: item2.dept_id, 
								hazardType: item2.hazard_type,
								id: item2.id,
								inventoryNum: item2.inventoryNum,
								isInspected: item2.is_inspected,
								// is_inspected
								isInspectedName: item2.is_inspected_name,
								model: item2.model,
								name: item2.name,
								notes: item2.notes,
								price: item2.price,
								spuId: item2.spuId,
								spuSn: item2.spu_sn,
								spuType: item2.spu_type,
								spuTypeName: item2.spu_type_name,
							    storageCond: item2.storage_cond,
								storageNum: item2.storage_num ,
								unit: item2.unit,
								updateBy: item2.update_by,
								// updateTime: item2.update_time,
								}
								
								array.details.push(list)
							})
							

							// data.push(array)

						// })
							console.log(array,'2222222222222222222222222')
						consumables_save(array).then(res => {
							if (res.code == 200) {
								this.profitvisible = false
								this.$message.success('保存成功')
								this.$emit('ok')
							} else {
								this.$message.error(res.msg)
							}
						})
					}
				})
			},
		},
	}
</script>
